module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_KathleenChalfant-1a6b2c5115ce6e9be351825a9bdf6bd8.png";